module.exports = __webpack_public_path__ + "img/facilityInfo_1_2.b375b95e.jpg";